module.exports = __webpack_public_path__ + "img/c4.4d0a722b.jpg";